import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import MoClaimSuccess from '@src/ui-components/mo-backpack/claim-success';
import ClaimSuccessModalStore from './store';

export const ClaimSuccessModal = ({ onClose, store }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  // 不把 React 事件透传为 useModal 的关闭回调
  const handleCloseClick = () => store.requestClose();

  return (
    <ModalContainer modalState={store.isOpen}>
      <MoClaimSuccess onClose={handleCloseClick} />
    </ModalContainer>
  );
};

export default wrapStore(ClaimSuccessModal, ClaimSuccessModalStore);
